<template>
  <v-dialog
    v-model="showPopup"
    persistent
    max-width="520"
    @keydown.passive.enter='doDelete'
    @keydown.passive.esc='$emit("cancel")'
  >
    <v-card class="pa-4">
      <v-card-title class="headline justify-center popup-title">
        Are you sure want to delete the warehouse "{{item.name}}"?
      </v-card-title>
      <v-card-text class="d-flex justify-center red--text">
        <p class="text-center">Attention! All folders and items in the warehouse will also be deleted.</p>
      </v-card-text>
      <v-card-actions class="text-xs-center justify-center">
        <v-btn
          @click="$emit('cancel')"
          depressed
          class="cancel-btn small-size"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="doDelete"
          depressed
          class="save-btn small-size"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import service from '@/services/warehouses'
export default {
  props: {
    showPopup: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    async doDelete() {
      const result = await service.deleteWarehouse({ id: this.item.id })
      if (result?.data?.error?.type === 200) {
        this.$store.dispatch('warehouses/loadWarehousesList')
        this.$emit('cancel')
      }
    }
  }
}
</script>
